import classes from "./SectionHeader.module.css";
import React from "react";
import SectionDivider from "../SectionDivider";

type SectionHeaderProps = {
  title: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const SectionHeader = (props: SectionHeaderProps) => {
  return (
    <React.Fragment>
      <div
        className={classes["header-wrapper"]}
        onClick={(e) => props.onClick && props.onClick(e)}
      >
        <div className={classes["header-text"]}>{props.title}</div>
        <SectionDivider />
      </div>
    </React.Fragment>
  );
};

export default SectionHeader;
